// extracted by mini-css-extract-plugin
export var callCard = "_qq-0";
export var callMessageButton = "_qq-1";
export var helpIcon = "_qq-3";
export var helpIconContainer = "_qq-4";
export var verticalDivider = "_qq-2";